import {
  BLOCK_UNBLOCK_SWITCH,
  GET_USER,
  GET_HISTORY,
  EDIT_COIN,
  ASSIGN_BADGE,
  ASSIGN_FRAME,
  ASSIGN_TAG,
  UPDATE_USERNAME,
  UPDATE_UNIQUE_ID,
  UPDATE_USER_COUNTRY, 
} from "./types";

const initialState = {
  user: [],
  male: 0,
  female: 0,
  totalUser: 0,
  activeUser: 0,
  history: [],
  totalHistoryUser: 0,
  income: 0,
  outgoing: 0,
  totalCallCharge: 0,
  liveStreamingIncome: 0,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER:
      return {
        ...state,
        user: action.payload.user,
        male: action.payload.male,
        female: action.payload.female,
        totalUser: action.payload.total,
        activeUser: action.payload.activeUser,
      };

    case BLOCK_UNBLOCK_SWITCH:
      return {
        ...state,
        user: state.user.map((u) =>
          u._id === action.payload._id
            ? { ...u, isBlock: action.payload.isBlock }
            : u
        ),
      };

    case GET_HISTORY:
      return {
        ...state,
        history: action.payload.history,
        totalHistoryUser: action.payload.total,
        income: action.payload.incomeTotal,
        outgoing: action.payload.outgoingTotal,
        totalCallCharge: action.payload.totalCallCharge,
        liveStreamingIncome: action.payload.income,
      };

    case EDIT_COIN:
      return {
        ...state,
        user: state.user.map((u) =>
          u._id === action.payload.id ? action.payload.data : u
        ),
      };

    case ASSIGN_BADGE:
      return {
        ...state,
        user: state.user.map((u) =>
          u._id === action.payload._id ? action.payload : u
        ),
      };

    case ASSIGN_FRAME:
      return {
        ...state,
        user: state.user.map((u) =>
          u._id === action.payload._id ? action.payload : u
        ),
      };

    case ASSIGN_TAG:
      return {
        ...state,
        user: state.user.map((u) =>
          u._id === action.payload._id ? action.payload : u
        ),
      };

    case UPDATE_USERNAME:
      return {
        ...state,
        user: state.user.map((u) =>
          u._id === action.payload.id
            ? { ...u, username: action.payload.username }
            : u
        ),
      };

    case UPDATE_UNIQUE_ID:
      return {
        ...state,
        user: state.user.map((u) =>
          u._id === action.payload.id
            ? { ...u, uniqueId: action.payload.uniqueId }
            : u
        ),
      };

    case UPDATE_USER_COUNTRY:
      return {
        ...state,
        user: state.user.map((u) =>
          u._id === action.payload._id ? action.payload : u
        ),
      };

    default:
      return state;
  }
};

export default userReducer;
